// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23212529%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard.openSidebar .dashboard__mainPage .dashboard__content .giftcard_mainbox .gc_contentbox {
  margin-left: 25%;
}

.gc_content {
  margin-bottom: 20px;
  color: #000;
}

.signUpPage__formSection .form-group label {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.campaignSelection__boxes {
  width: 100%;
  padding: 0 2rem;
}
@media screen and (max-width: 767px) {
  .campaignSelection__boxes {
    padding: 1.5rem;
  }
}
.campaignSelection__boxes .giftcard_voucher_box {
  border-radius: 0.5rem;
  background-color: #fff;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: center;
  border: 1px solid rgba(0, 0, 0, 0.35);
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
}
.campaignSelection__boxes .giftcard_voucher_box.selected_voucher .giftcard_voucher_details {
  background-color: #2056a5;
}
.campaignSelection__boxes .giftcard_voucher_box.selected_voucher .giftcard_voucher_details .giftcard_voucher_title h5 {
  color: #FFF;
}
.campaignSelection__boxes .giftcard_voucher_box .gc_imagebox {
  position: relative;
  height: 150px;
  display: inline-flex;
  align-items: center;
  max-height: 150px;
  width: 100%;
}
.campaignSelection__boxes .giftcard_voucher_box .gc_imagebox img {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  max-height: 150px;
  width: 100%;
}
.campaignSelection__boxes .giftcard_voucher_box .gc_imagebox .giftcard_voucher_selected {
  position: absolute;
  width: 20px;
  height: 20px;
  background-color: #2056a5;
  border-radius: 10px;
  top: 8px;
  right: 8px;
}
.campaignSelection__boxes .giftcard_voucher_box .gc_imagebox .giftcard_voucher_selected:before {
  content: "";
  width: 5px;
  height: 10px;
  position: absolute;
  border-right: 1px solid #fff;
  border-bottom: 1px solid #FFF;
  right: 7px;
  transform: rotate(45deg);
  top: 4px;
}
.campaignSelection__boxes .giftcard_voucher_box .gc_imagebox .gc_overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.62);
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  display: none;
}
.campaignSelection__boxes .giftcard_voucher_box .gc_imagebox .gc_overlay .gc_overlay_box {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.campaignSelection__boxes .giftcard_voucher_box .gc_imagebox .gc_overlay .gc_overlay_box ul {
  padding: 0;
  margin: 0;
  text-align: center;
}
.campaignSelection__boxes .giftcard_voucher_box .gc_imagebox .gc_overlay .gc_overlay_box ul li {
  list-style: none;
  display: block;
  margin-bottom: 5px;
}
.campaignSelection__boxes .giftcard_voucher_box .gc_imagebox .gc_overlay .gc_overlay_box ul li:last-child {
  margin-bottom: 0;
}
.campaignSelection__boxes .giftcard_voucher_box .gc_imagebox .gc_overlay .gc_overlay_box ul li a {
  color: #000;
  font-size: 12px;
  padding: 5px;
  border-radius: 4px;
  background-color: #e3f2fd;
  font-weight: 600;
  width: 100px;
  display: block;
  text-align: center;
  border: 1px solid #e3f2fd;
}
.campaignSelection__boxes .giftcard_voucher_box .gc_imagebox .gc_overlay .gc_overlay_box ul li a:hover {
  background-color: #0e3979;
  color: #FFF;
  border-color: #0e3979;
}
.campaignSelection__boxes .giftcard_voucher_box .giftcard_voucher_details {
  margin: 0;
  align-items: center;
  padding: 10px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  display: flex;
  justify-content: space-between;
  background-color: #e3f2fd;
  width: 100%;
}
.campaignSelection__boxes .giftcard_voucher_box .giftcard_voucher_details .giftcard_voucher_title {
  display: block;
  width: 100%;
  padding: 0;
  color: #000;
  text-align: center;
}
.campaignSelection__boxes .giftcard_voucher_box .giftcard_voucher_details .giftcard_voucher_title h5 {
  font-weight: 600;
  color: #000;
  margin-bottom: 0;
  font-size: 13px;
  overflow: hidden;
  white-space: pre;
  text-overflow: ellipsis;
}
@media screen and (max-width: 767px) {
  .campaignSelection__boxes .giftcard_voucher_box .giftcard_voucher_details .giftcard_voucher_title h5 {
    overflow: hidden;
    white-space: pre;
    text-overflow: ellipsis;
  }
}
.campaignSelection__boxes .giftcard_voucher_box .giftcard_voucher_details .giftcard_voucher_button {
  display: flex;
  width: calc(30% - 5px);
  padding: 0;
  justify-content: end;
}
.campaignSelection__boxes .giftcard_voucher_box .giftcard_voucher_details .giftcard_voucher_button .form-check {
  min-height: 0;
  padding-left: 0;
  margin-bottom: 0;
}
.campaignSelection__boxes .giftcard_voucher_box .giftcard_voucher_details .giftcard_voucher_button button {
  font-size: 10px;
  padding: 2px 10px;
  border-radius: 4px;
}
.campaignSelection__boxes .giftcard_voucher_box:hover .gc_overlay {
  display: block;
}

.no_giftcard_box {
  text-align: center;
}
.no_giftcard_box img {
  margin-bottom: 1rem;
}
.no_giftcard_box h6 {
  color: #000;
  margin-bottom: 0.8rem;
}
.no_giftcard_box a {
  border-radius: 1rem;
}

.gc_modal_box {
  overflow: hidden;
}
.gc_modal_box .gc_title {
  margin-bottom: 1rem;
}
.gc_modal_box .gc_title h5 {
  color: #000;
  display: flex;
  align-items: center;
  margin-bottom: 0;
}
.gc_modal_box .gc_title h5 span {
  color: #2056a5;
  margin-left: 5px;
}
.gc_modal_box .gc_amount {
  display: flex;
  align-items: start;
  margin-bottom: 1rem;
}
.gc_modal_box .gc_amount h5 {
  color: #000;
  margin-bottom: 0;
}
.gc_modal_box .gc_amount span.gc_amount_box {
  margin-left: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.gc_modal_box .gc_amount span.gc_amount_box span.gc_amount_single {
  padding: 5px 8px;
  margin-right: 5px;
  border: 1px solid #ccc;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  border-radius: 4px;
  color: #2056a5;
  font-weight: 500;
  min-width: 75px;
  text-align: center;
}
.gc_modal_box h5 {
  color: #000;
  display: flex;
  align-items: center;
}
.gc_modal_box h5 span span span {
  padding: 5px;
  border: 1px solid #ccc;
  pointer-events: none;
  font-size: 12px;
}
.gc_modal_box ul {
  border: none !important;
}
.gc_modal_box ul li {
  width: 25% !important;
  padding: 0.8rem;
}
.gc_modal_box ul li:nth-child(1) {
  padding-left: 0.8rem;
}

.giftcard_mainbox {
  display: flex;
  align-items: start;
  width: 100%;
  overflow: hidden;
}
@media only screen and (max-width: 767px) {
  .giftcard_mainbox {
    flex-direction: column;
  }
}
.giftcard_mainbox .gc_sidebar {
  width: 20%;
  height: calc(100vh - 120px);
  padding: 1rem;
  border-right: 1px solid rgba(0, 0, 0, 0.15);
  position: fixed;
}
@media only screen and (max-width: 767px) {
  .giftcard_mainbox .gc_sidebar {
    width: 100%;
    height: auto;
    overflow: hidden;
    position: relative;
    border-right: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
    padding: 0;
  }
}
.giftcard_mainbox .gc_sidebar button.open_country_box {
  padding: 0.5rem;
  background-color: transparent;
  border: none;
  display: flex;
  width: 100%;
  margin-bottom: 0.5rem;
  justify-content: space-between;
  align-items: center;
}
.giftcard_mainbox .gc_sidebar button.open_country_box h3 {
  margin-bottom: 0;
  font-size: 1.4rem;
}
.giftcard_mainbox .gc_sidebar button:after {
  width: 1.25rem;
  height: 1.25rem;
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: 1.25rem;
  transition: transform 0.2s ease-in-out;
}
.giftcard_mainbox .gc_sidebar .gc_sidebar_innerbox button {
  padding: 0.25rem 0.5rem;
  border: none;
  background-color: transparent;
  font-size: 1.2rem;
  font-weight: 600;
  display: flex;
  width: 100%;
  margin-bottom: 0.5rem;
  align-items: center;
}
.giftcard_mainbox .gc_sidebar .gc_sidebar_innerbox button:after {
  width: 1.25rem;
  height: 1.25rem;
  margin-right: 0.5rem;
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: 1.25rem;
  transition: transform 0.2s ease-in-out;
  right: 8px;
  position: absolute;
}
.giftcard_mainbox .gc_sidebar .gc_sidebar_innerbox .signUpPage__formSection .country-select-form-box {
  height: 100vh;
  overflow-y: auto;
  padding: 0.4rem;
}
.giftcard_mainbox .gc_sidebar h4 {
  margin-bottom: 1rem;
  position: relative;
  cursor: pointer;
  color: #000;
  font-weight: 600;
}
.giftcard_mainbox .gc_sidebar input[type=text] {
  width: 100%;
  padding: 0.5rem;
  outline: none;
  border-radius: 0.25rem;
  border: 1px solid #000;
  margin-bottom: 1rem;
}
.giftcard_mainbox .gc_sidebar input[type=text]:focus {
  border-color: #2056a5;
}
.giftcard_mainbox .gc_sidebar .select_all_countries {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  font-weight: 800;
  color: #000;
  position: relative;
}
.giftcard_mainbox .gc_sidebar ul {
  padding-left: 0;
  display: flex;
  justify-content: space-between;
}
.giftcard_mainbox .gc_sidebar ul li {
  list-style: none;
  font-weight: 600;
  color: #000;
  text-overflow: ellipsis;
  white-space: pre;
  overflow: hidden;
  margin-right: 10px;
  margin-right: 10px;
}
.giftcard_mainbox .gc_sidebar .country-select-form-box {
  overflow-y: auto;
  padding: 0 0.5rem;
  height: calc(100vh - 300px);
}
@media only screen and (max-width: 767px) {
  .giftcard_mainbox .gc_sidebar .country-select-form-box {
    max-height: 100px;
    overflow-y: auto;
    padding: 0 0.5rem;
  }
}
.giftcard_mainbox .form-group input[type=checkbox] {
  width: 15px;
  height: 15px;
  margin: 0;
}
@media only screen and (max-width: 767px) {
  .giftcard_mainbox .form-group input[type=checkbox] {
    width: 10px;
    height: 10px;
  }
}
.giftcard_mainbox .gc_contentbox {
  width: 80%;
  height: auto;
  padding: 1.5rem;
  margin-left: 22%;
}
@media only screen and (max-width: 767px) {
  .giftcard_mainbox .gc_contentbox {
    width: 100%;
    margin-left: 0;
    padding: 0;
    padding-top: 0.8rem;
  }
}
.giftcard_mainbox .gc_contentbox input[type=checkbox] {
  width: 15px;
  height: 15px;
  margin: 0;
}
@media only screen and (max-width: 767px) {
  .giftcard_mainbox .gc_contentbox input[type=checkbox] {
    width: 10px;
    height: 10px;
  }
}
.giftcard_mainbox .gc_contentbox .gc_content_pbox {
  width: 100%;
}
.giftcard_mainbox .gc_contentbox .gc_content_pbox input[type=text] {
  width: 100%;
  padding: 0.5rem;
  outline: none;
  border-radius: 0.25rem;
  border: 1px solid #000;
  margin-bottom: 1rem;
}
.giftcard_mainbox .gc_contentbox .gc_content_pbox input[type=text]:focus {
  border-color: #2056a5;
}
.giftcard_mainbox .gc_contentbox .gc_content_pbox .select_all_giftcard {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.8rem;
  font-weight: 600;
  color: #000;
  padding: 0 20px;
  padding: 0 20px;
}
.giftcard_mainbox .gc_contentbox .gc_content_pbox .accordion-item {
  margin-bottom: 1rem;
}
.giftcard_mainbox .gc_contentbox .gc_content_pbox .accordion-item .accordion-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.giftcard_mainbox .gc_contentbox .gc_content_pbox .accordion-item .accordion-header .accordion-button {
  background-color: #FFF;
  color: #000;
  font-weight: 600;
}
.giftcard_mainbox .gc_contentbox .gc_content_pbox .accordion-item .accordion-header .accordion-button.collapsed {
  font-weight: 400;
}
.giftcard_mainbox .gc_contentbox .gc_content_pbox .accordion-item .accordion-header .accordion-button:before {
  width: var(--bs-accordion-btn-icon-width);
  height: var(--bs-accordion-btn-icon-width);
  margin-right: 0.5rem;
  content: "";
  background-image: var(--bs-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--bs-accordion-btn-icon-width);
  transition: var(--bs-accordion-btn-icon-transition);
}
.giftcard_mainbox .gc_contentbox .gc_content_pbox .accordion-item .accordion-header .accordion-button:after {
  content: none;
}
.giftcard_mainbox .gc_contentbox .gc_content_pbox .accordion-item .accordion-header input {
  margin-right: 1rem;
}
.giftcard_mainbox .gc_contentbox .gc_content_pbox .accordion-item .accordion-body {
  display: flex;
  flex-wrap: wrap;
}
.giftcard_mainbox .gc_contentbox .gc_content_pbox .accordion-item .accordion-body .campaignSelection__boxes {
  padding: 0;
}
.giftcard_mainbox .gc_contentbox .gc_content_pbox .accordion-item .accordion-body .gc_inmainbox {
  display: flex;
  justify-content: start;
  align-items: center;
  flex-wrap: wrap;
}
.giftcard_mainbox .gc_contentbox .gc_content_pbox .accordion-item .accordion-body .gc_inmainbox .gc_innbox {
  width: calc(20% - 10px);
  margin-right: 10px;
  display: flex;
  margin-bottom: 20px;
  flex-flow: column;
}
@media only screen and (max-width: 767px) {
  .giftcard_mainbox .gc_contentbox .gc_content_pbox .accordion-item .accordion-body .gc_inmainbox .gc_innbox {
    width: calc(50% - 10px);
    margin-bottom: 20px;
  }
}
.giftcard_mainbox .gc_contentbox .gc_content_pbox .campaignSelection__boxes {
  padding: 0;
}
.giftcard_mainbox .gc_contentbox .gc_content_pbox .campaignSelection__boxes .gc_inmainbox {
  display: flex;
  justify-content: start;
  align-items: center;
  flex-wrap: wrap;
}
.giftcard_mainbox .gc_contentbox .gc_content_pbox .campaignSelection__boxes .gc_inmainbox .gc_innbox {
  width: calc(20% - 10px);
  margin-right: 10px;
  display: flex;
  margin-bottom: 20px;
  flex-flow: column;
}
@media only screen and (max-width: 767px) {
  .giftcard_mainbox .gc_contentbox .gc_content_pbox .campaignSelection__boxes .gc_inmainbox .gc_innbox {
    width: calc(50% - 10px);
    margin-bottom: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/gift_voucher.scss"],"names":[],"mappings":"AAOgB;EACI,gBAAA;AANpB;;AAaA;EACI,mBAAA;EACA,WAAA;AAVJ;;AAeQ;EACI,eAAA;EACA,gBAAA;EACA,qBAAA;AAZZ;;AAiBA;EACI,WAAA;EACA,eAAA;AAdJ;AAgBI;EAJJ;IAKQ,eAAA;EAbN;AACF;AAeI;EACI,qBAAA;EACA,sBAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;EACA,uBAAA;EACA,qCAAA;EACA,iDAAA;AAbR;AAiBY;EACI,yBAAA;AAfhB;AAmBoB;EAAG,WAAA;AAhBvB;AAuBQ;EACI,kBAAA;EACA,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;AArBZ;AAuBY;EACI,4BAAA;EACA,6BAAA;EACA,iBAAA;EACA,WAAA;AArBhB;AAwBY;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,QAAA;EACA,UAAA;AAtBhB;AAwBgB;EACI,WAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,4BAAA;EACA,6BAAA;EACA,UAAA;EACA,wBAAA;EACA,QAAA;AAtBpB;AA4BY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,qCAAA;EACA,2BAAA;EACA,4BAAA;EACA,aAAA;AA1BhB;AA4BgB;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA1BpB;AA2BoB;EACI,UAAA;EACA,SAAA;EACA,kBAAA;AAzBxB;AA2BwB;EACI,gBAAA;EAEA,cAAA;EAEA,kBAAA;AA3B5B;AA6B4B;EACI,gBAAA;AA3BhC;AA8B4B;EACI,WAAA;EAEA,eAAA;EAEA,YAAA;EAEA,kBAAA;EAEA,yBAAA;EAEA,gBAAA;EAEA,YAAA;EAEA,cAAA;EAEA,kBAAA;EAEA,yBAAA;AArChC;AAuCgC;EACI,yBAAA;EACA,WAAA;EACA,qBAAA;AArCpC;AA8CQ;EACI,SAAA;EACA,mBAAA;EACA,aAAA;EACA,+BAAA;EACA,gCAAA;EACA,aAAA;EACA,8BAAA;EACA,yBAAA;EACA,WAAA;AA5CZ;AA8CY;EACI,cAAA;EAEA,WAAA;EAEA,UAAA;EAEA,WAAA;EAEA,kBAAA;AAhDhB;AAkDgB;EACI,gBAAA;EAEA,WAAA;EAEA,gBAAA;EAEA,eAAA;EAEA,gBAAA;EAEA,gBAAA;EAEA,uBAAA;AAtDpB;AAwDoB;EAfJ;IAgBQ,gBAAA;IAEA,gBAAA;IAEA,uBAAA;EAvDtB;AACF;AA2DY;EACI,aAAA;EAEA,sBAAA;EAEA,UAAA;EAEA,oBAAA;AA5DhB;AA8DgB;EACI,aAAA;EAEA,eAAA;EAEA,gBAAA;AA9DpB;AAiEgB;EACI,eAAA;EAEA,iBAAA;EAEA,kBAAA;AAjEpB;AAsEQ;EACI,cAAA;AApEZ;;AAyEA;EACI,kBAAA;AAtEJ;AAwEI;EACI,mBAAA;AAtER;AAyEI;EACI,WAAA;EACA,qBAAA;AAvER;AA0EI;EACI,mBAAA;AAxER;;AA4EA;EAEI,gBAAA;AA1EJ;AA4EI;EACI,mBAAA;AA1ER;AA4EQ;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AA1EZ;AA4EY;EACI,cAAA;EACA,gBAAA;AA1EhB;AA+EI;EAEI,aAAA;EACA,kBAAA;EACA,mBAAA;AA9ER;AAgFQ;EACI,WAAA;EACA,gBAAA;AA9EZ;AAiFQ;EACI,iBAAA;EACA,aAAA;EACA,eAAA;EACA,QAAA;AA/EZ;AAiFY;EACI,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,iDAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AA/EhB;AAmFI;EACI,WAAA;EACA,aAAA;EACA,mBAAA;AAjFR;AAqFgB;EACI,YAAA;EACA,sBAAA;EACA,oBAAA;EACA,eAAA;AAnFpB;AAyFI;EACI,uBAAA;AAvFR;AAyFQ;EACI,qBAAA;EACA,eAAA;AAvFZ;AAyFY;EACI,oBAAA;AAvFhB;;AA4FA;EACI,aAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;AAzFJ;AA2FI;EANJ;IAOQ,sBAAA;EAxFN;AACF;AA0FI;EACI,UAAA;EACA,2BAAA;EACA,aAAA;EACA,2CAAA;EACA,eAAA;AAxFR;AA0FQ;EAPJ;IAQQ,WAAA;IACA,YAAA;IACA,gBAAA;IACA,kBAAA;IACA,kBAAA;IACA,4CAAA;IACA,UAAA;EAvFV;AACF;AA0FY;EAEI,eAAA;EACA,6BAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,qBAAA;EACA,8BAAA;EACA,mBAAA;AAzFhB;AA2FgB;EACI,gBAAA;EACA,iBAAA;AAzFpB;AA6FY;EACI,cAAA;EACA,eAAA;EACA,WAAA;EACA,yDAAA;EACA,4BAAA;EACA,wBAAA;EACA,sCAAA;AA3FhB;AAiGY;EACI,uBAAA;EACA,YAAA;EACA,6BAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;EACA,qBAAA;EACA,mBAAA;AA/FhB;AAiGgB;EACI,cAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;EACA,yDAAA;EACA,4BAAA;EACA,wBAAA;EACA,sCAAA;EACA,UAAA;EACA,kBAAA;AA/FpB;AAqGgB;EACI,aAAA;EACA,gBAAA;EACA,eAAA;AAnGpB;AAwGQ;EACI,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAxbE;EAybF,gBAAA;AAtGZ;AAyGQ;EACI,WAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBAAA;AAvGZ;AAyGY;EACI,qBAAA;AAvGhB;AA2GQ;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WA/cE;EAgdF,kBAAA;AAzGZ;AA4GQ;EACI,eAAA;EACA,aAAA;EACA,8BAAA;AA1GZ;AA4GY;EACI,gBAAA;EACA,gBAAA;EACA,WA3dF;EA4dE,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AA1GhB;AAgHQ;EAEI,gBAAA;EACA,iBAAA;EACA,2BAAA;AA/GZ;AAiHY;EANJ;IAOQ,iBAAA;IACA,gBAAA;IACA,iBAAA;EA9Gd;AACF;AAqHQ;EACI,WAAA;EACA,YAAA;EACA,SAAA;AAnHZ;AAqHY;EALJ;IAMQ,WAAA;IACA,YAAA;EAlHd;AACF;AAuHI;EACI,UAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AArHR;AAuHQ;EANJ;IAOQ,WAAA;IACA,cAAA;IACA,UAAA;IACA,mBAAA;EApHV;AACF;AAsHQ;EACI,WAAA;EACA,YAAA;EACA,SAAA;AApHZ;AAsHY;EALJ;IAMQ,WAAA;IACA,YAAA;EAnHd;AACF;AAsHQ;EACI,WAAA;AApHZ;AAsHY;EACI,WAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBAAA;AApHhB;AAsHgB;EACI,qBAAA;AApHpB;AAwHY;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,WAljBF;EAmjBE,eAAA;EACA,eAAA;AAtHhB;AAyHY;EAEI,mBAAA;AAxHhB;AA0HgB;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AAxHpB;AA0HoB;EAEQ,sBAAA;EACA,WAAA;EACA,gBAAA;AAzH5B;AA2HwB;EACI,gBAAA;AAzH5B;AA4HwB;EACI,yCAAA;EACA,0CAAA;EACA,oBAAA;EACA,WAAA;EACA,8CAAA;EACA,4BAAA;EACA,mDAAA;EACA,mDAAA;AA1H5B;AA6HwB;EACI,aAAA;AA3H5B;AAiIoB;EACI,kBAAA;AA/HxB;AAmIgB;EACI,aAAA;EACA,eAAA;AAjIpB;AAmIoB;EACI,UAAA;AAjIxB;AAoIoB;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AAlIxB;AAqIwB;EACI,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AAnI5B;AAqI4B;EAPJ;IASQ,uBAAA;IACA,mBAAA;EAnI9B;AACF;AAyIY;EACI,UAAA;AAvIhB;AAyIgB;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AAvIpB;AAyIoB;EAEI,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AAxIxB;AA0IwB;EARJ;IAUQ,uBAAA;IACA,mBAAA;EAxI1B;AACF","sourcesContent":["$mobileBig: 767px;\r\n$color-black: #000;\r\n\r\n.dashboard.openSidebar{\r\n    .dashboard__mainPage{\r\n        .dashboard__content{\r\n            .giftcard_mainbox{\r\n                .gc_contentbox{\r\n                    margin-left: 25%;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.gc_content {\r\n    margin-bottom: 20px;\r\n    color: #000;\r\n}\r\n\r\n.signUpPage__formSection {\r\n    .form-group {\r\n        label {\r\n            font-size: 16px;\r\n            font-weight: 600;\r\n            margin-bottom: 0.5rem;\r\n        }\r\n    }\r\n}\r\n\r\n.campaignSelection__boxes {\r\n    width: 100%;\r\n    padding: 0 2rem;\r\n\r\n    @media screen and (max-width: $mobileBig) {\r\n        padding: 1.5rem;\r\n    }\r\n\r\n    .giftcard_voucher_box {\r\n        border-radius: 0.5rem;\r\n        background-color: #fff;\r\n        display: flex;\r\n        flex-wrap: wrap;\r\n        width: 100%;\r\n        justify-content: center;\r\n        border: 1px solid rgba(0,0,0, 0.35);\r\n        box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\r\n\r\n        &.selected_voucher{\r\n\r\n            .giftcard_voucher_details{\r\n                background-color: #2056a5;\r\n\r\n                .giftcard_voucher_title{\r\n\r\n                    h5{color: #FFF;}\r\n\r\n                }\r\n                \r\n            }\r\n        }\r\n\r\n        .gc_imagebox {\r\n            position: relative;\r\n            height: 150px;\r\n            display: inline-flex;\r\n            align-items: center;\r\n            max-height: 150px;\r\n            width: 100%;\r\n\r\n            img {\r\n                border-top-left-radius: 10px;\r\n                border-top-right-radius: 10px;\r\n                max-height: 150px;\r\n                width: 100%;\r\n            }\r\n\r\n            .giftcard_voucher_selected{\r\n                position: absolute;\r\n                width: 20px;\r\n                height: 20px;\r\n                background-color: #2056a5;\r\n                border-radius: 10px;\r\n                top: 8px;\r\n                right: 8px;\r\n\r\n                &:before{\r\n                    content: \"\";\r\n                    width: 5px;\r\n                    height: 10px;\r\n                    position: absolute;\r\n                    border-right: 1px solid #fff;\r\n                    border-bottom: 1px solid #FFF;\r\n                    right: 7px;\r\n                    transform: rotate(45deg);\r\n                    top: 4px;\r\n                }\r\n            }\r\n\r\n            \r\n\r\n            .gc_overlay {\r\n                width: 100%;\r\n                height: 100%;\r\n                position: absolute;\r\n                top: 0;\r\n                left: 0;\r\n                background-color: rgba(0, 0, 0, 0.62);\r\n                border-top-left-radius: 5px;\r\n                border-top-right-radius: 5px;\r\n                display: none;\r\n\r\n                .gc_overlay_box {\r\n                    width: 100%;\r\n                    height: 100%;\r\n                    display: flex;\r\n                    align-items: center;\r\n                    justify-content: center;\r\n                    ul {\r\n                        padding: 0;\r\n                        margin: 0;\r\n                        text-align: center;\r\n\r\n                        li {\r\n                            list-style: none;\r\n\r\n                            display: block;\r\n\r\n                            margin-bottom: 5px;\r\n\r\n                            &:last-child {\r\n                                margin-bottom: 0;\r\n                            }\r\n\r\n                            a {\r\n                                color: #000;\r\n\r\n                                font-size: 12px;\r\n\r\n                                padding: 5px;\r\n\r\n                                border-radius: 4px;\r\n\r\n                                background-color: #e3f2fd;\r\n\r\n                                font-weight: 600;\r\n\r\n                                width: 100px;\r\n\r\n                                display: block;\r\n\r\n                                text-align: center;\r\n\r\n                                border: 1px solid #e3f2fd;\r\n\r\n                                &:hover {\r\n                                    background-color: #0e3979;\r\n                                    color: #FFF;\r\n                                    border-color: #0e3979;\r\n                                }\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        .giftcard_voucher_details {\r\n            margin: 0;\r\n            align-items: center;\r\n            padding: 10px;\r\n            border-bottom-left-radius: 10px;\r\n            border-bottom-right-radius: 10px;\r\n            display: flex;\r\n            justify-content: space-between;\r\n            background-color: #e3f2fd;\r\n            width: 100%;\r\n\r\n            .giftcard_voucher_title {\r\n                display: block;\r\n\r\n                width: calc(100%);\r\n\r\n                padding: 0;\r\n\r\n                color: #000;\r\n\r\n                text-align: center;\r\n\r\n                h5 {\r\n                    font-weight: 600;\r\n\r\n                    color: #000;                    \r\n\r\n                    margin-bottom: 0;\r\n\r\n                    font-size: 13px;\r\n\r\n                    overflow: hidden;\r\n\r\n                    white-space: pre;\r\n\r\n                    text-overflow: ellipsis;\r\n\r\n                    @media screen and (max-width: $mobileBig) {\r\n                        overflow: hidden;\r\n\r\n                        white-space: pre;\r\n\r\n                        text-overflow: ellipsis;\r\n                    }\r\n                }\r\n            }\r\n\r\n            .giftcard_voucher_button {\r\n                display: flex;\r\n\r\n                width: calc(30% - 5px);\r\n\r\n                padding: 0;\r\n\r\n                justify-content: end;\r\n\r\n                .form-check {\r\n                    min-height: 0;\r\n\r\n                    padding-left: 0;\r\n\r\n                    margin-bottom: 0;\r\n                }\r\n\r\n                button {\r\n                    font-size: 10px;\r\n\r\n                    padding: 2px 10px;\r\n\r\n                    border-radius: 4px;\r\n                }\r\n            }\r\n        }\r\n\r\n        &:hover .gc_overlay {\r\n            display: block;\r\n        }\r\n    }\r\n}\r\n\r\n.no_giftcard_box {\r\n    text-align: center;\r\n\r\n    img {\r\n        margin-bottom: 1rem;\r\n    }\r\n\r\n    h6 {\r\n        color: #000;\r\n        margin-bottom: 0.8rem;\r\n    }\r\n\r\n    a {\r\n        border-radius: 1rem;\r\n    }\r\n}\r\n\r\n.gc_modal_box {\r\n\r\n    overflow: hidden;\r\n    \r\n    .gc_title {\r\n        margin-bottom: 1rem;\r\n\r\n        h5 {\r\n            color: #000;\r\n            display: flex;\r\n            align-items: center;\r\n            margin-bottom: 0;\r\n\r\n            span {\r\n                color: #2056a5;\r\n                margin-left: 5px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .gc_amount {\r\n\r\n        display: flex;\r\n        align-items: start;\r\n        margin-bottom: 1rem;\r\n\r\n        h5 {\r\n            color: #000;\r\n            margin-bottom: 0;\r\n        }\r\n\r\n        span.gc_amount_box {\r\n            margin-left: 10px;\r\n            display: flex;\r\n            flex-wrap: wrap;\r\n            gap: 8px;\r\n\r\n            span.gc_amount_single {\r\n                padding: 5px 8px;\r\n                margin-right: 5px;\r\n                border: 1px solid #ccc;\r\n                box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\r\n                border-radius: 4px;\r\n                color: #2056a5;\r\n                font-weight: 500;\r\n                min-width: 75px;\r\n                text-align: center;\r\n            }\r\n        }\r\n    }\r\n    h5 {\r\n        color: #000;\r\n        display: flex;\r\n        align-items: center;\r\n\r\n        span {\r\n            span {\r\n                span {\r\n                    padding: 5px;\r\n                    border: 1px solid #ccc;\r\n                    pointer-events: none;\r\n                    font-size: 12px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    ul {\r\n        border: none !important;\r\n\r\n        li {\r\n            width: 25% !important;\r\n            padding: 0.8rem;\r\n\r\n            &:nth-child(1) {\r\n                padding-left: 0.8rem;\r\n            }\r\n        }\r\n    }\r\n}\r\n.giftcard_mainbox {\r\n    display: flex;\r\n    align-items: start;\r\n    width: 100%;\r\n    overflow: hidden;\r\n\r\n    @media only screen and (max-width: $mobileBig) {\r\n        flex-direction: column;\r\n    }\r\n\r\n    .gc_sidebar {\r\n        width: 20%;\r\n        height: calc(100vh - 120px);\r\n        padding: 1rem;\r\n        border-right: 1px solid rgba(0, 0, 0, 0.15);\r\n        position: fixed;\r\n\r\n        @media only screen and (max-width: $mobileBig){\r\n            width: 100%;\r\n            height: auto;\r\n            overflow: hidden;\r\n            position: relative;\r\n            border-right: none;\r\n            border-bottom: 1px solid rgba(0, 0, 0, 0.15);\r\n            padding: 0;\r\n        }\r\n\r\n        button{\r\n            &.open_country_box{\r\n\r\n                padding: 0.5rem;\r\n                background-color: transparent;\r\n                border: none;\r\n                display: flex;\r\n                width: 100%;\r\n                margin-bottom: 0.5rem;\r\n                justify-content: space-between;\r\n                align-items: center;\r\n\r\n                h3{\r\n                    margin-bottom: 0;\r\n                    font-size: 1.4rem;\r\n                }\r\n            }\r\n\r\n            &:after{\r\n                width:  1.25rem;;\r\n                height:  1.25rem;;\r\n                content: \"\";\r\n                background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23212529'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\r\n                background-repeat: no-repeat;\r\n                background-size: 1.25rem;\r\n                transition: transform 0.2s ease-in-out;;\r\n            }\r\n        }\r\n\r\n        .gc_sidebar_innerbox{\r\n            \r\n            button{\r\n                padding: 0.25rem 0.5rem;\r\n                border: none;\r\n                background-color: transparent;\r\n                font-size: 1.2rem;\r\n                font-weight: 600;\r\n                display: flex;\r\n                width: 100%;\r\n                margin-bottom: 0.5rem;\r\n                align-items: center;\r\n\r\n                &:after{\r\n                    width: 1.25rem;\r\n                    height: 1.25rem;\r\n                    margin-right: 0.5rem;\r\n                    content: \"\";\r\n                    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23212529'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\r\n                    background-repeat: no-repeat;\r\n                    background-size: 1.25rem;\r\n                    transition: transform 0.2s ease-in-out;\r\n                    right: 8px;\r\n                    position: absolute;\r\n                }\r\n            }\r\n\r\n            .signUpPage__formSection{\r\n            \r\n                .country-select-form-box{\r\n                    height: 100vh;\r\n                    overflow-y: auto;\r\n                    padding: 0.4rem;\r\n                }\r\n            }\r\n        }\r\n\r\n        h4 {\r\n            margin-bottom: 1rem;\r\n            position: relative;\r\n            cursor: pointer;\r\n            color: $color-black;\r\n            font-weight: 600;\r\n        }\r\n\r\n        input[type=\"text\"] {\r\n            width: 100%;\r\n            padding: 0.5rem;\r\n            outline: none;\r\n            border-radius: 0.25rem;\r\n            border: 1px solid #000;\r\n            margin-bottom: 1rem;\r\n\r\n            &:focus{\r\n                border-color: #2056a5;\r\n            }\r\n        }\r\n\r\n        .select_all_countries{\r\n            display: flex;\r\n            justify-content: space-between;\r\n            align-items: center;\r\n            margin-bottom: 1rem;\r\n            font-weight: 800;\r\n            color: $color-black;\r\n            position: relative;\r\n        }\r\n\r\n        ul{\r\n            padding-left: 0;\r\n            display: flex;\r\n            justify-content: space-between;\r\n\r\n            li{\r\n                list-style: none;\r\n                font-weight: 600;\r\n                color: $color-black;\r\n                text-overflow: ellipsis;\r\n                white-space: pre;\r\n                overflow: hidden;\r\n                margin-right: 10px;\r\n                margin-right: 10px;\r\n            }\r\n        }\r\n\r\n        \r\n\r\n        .country-select-form-box{\r\n\r\n            overflow-y: auto;\r\n            padding: 0 0.5rem;\r\n            height: calc(100vh - 300px);\r\n\r\n            @media only screen and (max-width: $mobileBig) {\r\n                max-height: 100px;\r\n                overflow-y: auto;\r\n                padding: 0 0.5rem;\r\n            }\r\n        }\r\n        \r\n    }\r\n\r\n    .form-group{\r\n\r\n        input[type=checkbox]{\r\n            width: 15px;\r\n            height: 15px;\r\n            margin: 0;\r\n\r\n            @media only screen and (max-width: $mobileBig) {\r\n                width: 10px;\r\n                height: 10px;\r\n            }\r\n        }\r\n\r\n    }\r\n\r\n    .gc_contentbox {\r\n        width: 80%;\r\n        height: auto;\r\n        padding: 1.5rem;\r\n        margin-left: 22%;\r\n\r\n        @media only screen and (max-width: $mobileBig) {\r\n            width: 100%;\r\n            margin-left: 0;\r\n            padding: 0;\r\n            padding-top: 0.8rem;\r\n        }\r\n\r\n        input[type=checkbox]{\r\n            width: 15px;\r\n            height: 15px;\r\n            margin: 0;\r\n\r\n            @media only screen and (max-width: $mobileBig) {\r\n                width: 10px;\r\n                height: 10px;\r\n            }\r\n        }\r\n\r\n        .gc_content_pbox{\r\n            width: 100%;\r\n\r\n            input[type=\"text\"] {\r\n                width: 100%;\r\n                padding: 0.5rem;\r\n                outline: none;\r\n                border-radius: 0.25rem;\r\n                border: 1px solid #000;\r\n                margin-bottom: 1rem;\r\n    \r\n                &:focus{\r\n                    border-color: #2056a5;\r\n                }\r\n            }\r\n\r\n            .select_all_giftcard{\r\n                display: flex;\r\n                justify-content: space-between;\r\n                align-items: center;\r\n                margin-bottom: 0.8rem;\r\n                font-weight: 600;\r\n                color: $color-black;\r\n                padding: 0 20px;\r\n                padding: 0 20px;\r\n            }\r\n\r\n            .accordion-item{\r\n\r\n                margin-bottom: 1rem;\r\n\r\n                .accordion-header{\r\n                    display: flex;\r\n                    justify-content: space-between;\r\n                    align-items: center;\r\n\r\n                    .accordion-button{\r\n\r\n                            background-color: #FFF;\r\n                            color: #000;\r\n                            font-weight: 600;\r\n\r\n                        &.collapsed{\r\n                            font-weight: 400;   \r\n                        }\r\n\r\n                        &:before{\r\n                            width: var(--bs-accordion-btn-icon-width);\r\n                            height: var(--bs-accordion-btn-icon-width);\r\n                            margin-right: 0.5rem;\r\n                            content: \"\";\r\n                            background-image: var(--bs-accordion-btn-icon);\r\n                            background-repeat: no-repeat;\r\n                            background-size: var(--bs-accordion-btn-icon-width);\r\n                            transition: var(--bs-accordion-btn-icon-transition);\r\n                        }\r\n\r\n                        &:after{\r\n                            content: none;\r\n                        }\r\n                    }\r\n\r\n                    \r\n\r\n                    input{\r\n                        margin-right: 1rem;\r\n                    }\r\n                }\r\n\r\n                .accordion-body{\r\n                    display: flex;\r\n                    flex-wrap: wrap;\r\n\r\n                    .campaignSelection__boxes{\r\n                        padding: 0;\r\n                    }\r\n\r\n                    .gc_inmainbox{\r\n                        display: flex;\r\n                        justify-content: start;\r\n                        align-items: center;\r\n                        flex-wrap: wrap;\r\n\r\n\r\n                        .gc_innbox{\r\n                            width: calc(20% - 10px);\r\n                            margin-right: 10px;\r\n                            display: flex;\r\n                            margin-bottom: 20px;\r\n                            flex-flow: column;\r\n\r\n                            @media only screen and (max-width: $mobileBig){\r\n\r\n                                width: calc(100%/2 - 10px );\r\n                                margin-bottom: 20px;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n\r\n            .campaignSelection__boxes{\r\n                padding: 0;\r\n\r\n                .gc_inmainbox{\r\n                    display: flex;\r\n                    justify-content: start;\r\n                    align-items: center;\r\n                    flex-wrap: wrap;\r\n\r\n                    .gc_innbox{\r\n\r\n                        width: calc(100%/5 - 10px);\r\n                        margin-right: 10px;\r\n                        display: flex;\r\n                        margin-bottom: 20px;\r\n                        flex-flow: column;\r\n\r\n                        @media only screen and (max-width: $mobileBig){\r\n\r\n                            width: calc(100%/2 - 10px );\r\n                            margin-bottom: 20px;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
